import * as React from "react";
import { Component } from "react";
import { Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { IBaseState } from "src/interfaces";
import "../../css/components/layout/solarwebnavbar.css";
import { INavbarProps } from "./interfaces";
import SignedInLinks from "./SignedInLinks";
import SignedOutLinks from "./SignedOutLinks";

export default class SolarWebNavbar extends Component<INavbarProps, IBaseState> {
  public constructor(props: INavbarProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const { appService } = this.props;

    const links = appService.isAuthenticated() ? (
      <SignedInLinks
        appService={appService}
        history={this.props.history}
        setUser={this.props.setUser}
      />
    ) : (
      <SignedOutLinks
        history={this.props.history}
        setUser={this.props.setUser}
        appService={appService}
      />
    );

    return (
      <div className="container-fixed-navbar">
        <div className="solarweb-navbar-container">
          <Navbar className="solarWebNavbar" inverse={true} collapseOnSelect={true} fixedTop={true}>
            <Navbar.Header>
              <Navbar.Brand>
                <NavLink to="/">Solar Web Tracker</NavLink>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>{links}</Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/SolarWebNavbar.tsx